import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';

@Component({
  selector: 'app-referred-frequent-questions',
  templateUrl: './referred-frequent-questions.component.html',
  styleUrls: ['./referred-frequent-questions.component.sass']
})
export class ReferredFrequentQuestionsComponent implements OnInit {
  @Output() updatescreenview = new EventEmitter<any>();
  public content:object;
  public expand = [];
  constructor(private global:GlobalService) { }

  ngOnInit() {
    this.global.validateSession();
    this.content={
      content:[
        {
          title:"¿Qué es el Programa de Referidos?",
          description:"El Programa de Referidos permite que cualquier cliente activo de Claro pueda referir nuevos clientes (sean éstos familiares, amigos o conocidos) sin importar el tiempo que lleve como cliente en Claro. Tanto el cliente existente, como la persona referida, podrían disfrutar de un descuento que está condicionado a que el cliente referido complete la adquisición del producto o servicio participante en el Programa.",
          expand:true
        },
        {
          title:"¿Qué hago para participar?",
          description:" &#8226; Si eres cliente existente CLARO, y tienes cuenta en Mi Claro, accede a la misma, ingresa la información requerida, acepta los términos y condiciones del Programa y comienza a referir.   <br> &#8226; Si eres cliente existente CLARO, y NO tienes cuenta en Mi Claro, accede al enlace Mi Claro para registrarte en https://miclaro.clarotodo.com/, crea tu cuenta, acepta los términos y condiciones del programa y comienza a referir.  <br> &#8226; Si NO eres cliente existente CLARO, activa uno de los productos o servicios aplicables del programa, crea tu cuenta en Mi Claro para tener acceso al Programa, acepta los términos y condiciones y comienza a referir. ",
          expand:false
        },
        {
          title:"¿Hay límite de referidos?",
          description:" No hay límite de referidos.  Cliente podrá acumular sus cupones, no obstante, solo podrá redimir un cupón por ciclo de factura.",
          expand:false
        },
        {
          title:"¿Cuáles son los productos a los cuales debo suscribirme para disfrutar de los beneficios del Programa de Referidos?",
          description:"&#8226; Móvil “Update” <br> &#8226; Byop / Credit Limit <br> <!--&#8226; Byop / Prepaid <br>--> &#8226; FIJO- 2Play y 3Play con contrato de 24 meses.",
          expand:false
        },
        {
          title:"¿Cuáles son los beneficios del Programa de Referidos?",
          description:" <p>El beneficio adquirido aplica para el pago o recarga de la factura del cliente.  El monto del beneficio adquirido puede variar por producto según aplique, estos son:</p><br><table class='tabla-planes'><thead style='background-color: #ef3829;color: #fff;'><tr><th>Productos Participantes</th><th>Beneficio que aplica</th></tr></thead><tbody><tr><td>Update</td><td>Cupón de $50 de descuento para pago de su factura</td></tr><tr><td>Byop/ Credit Limit</td><td>Cupón de $25 de descuento para pago de su factura</td></tr><!--<tr><td>Byop/ Prepaid</td><td>Cupón de Descuento $25.00 en una recarga</td></tr>--><tr><td>Fijo 2PLAY</td><td>50% de descuento en la renta del plan</td></tr><tr><td>Fijo 3play</td><td>50% de descuento en la renta del plan y de la renta del plan de televisión.</td></tr><tr><td>Individual Residencial<br>(Cuentas Convergentes-Móvil y Fijo)</td><td>50% de descuento en la renta del plan fijo (El descuento se incluye al plan de <a class='ClaroTv'>Claro</a><a class='tvmas'>tv+</a>, si la cuenta es 3Play.)</td></tr></tbody></table>",
          expand:false
        },
        {
          title:"¿Vigencia del cupón?",
          description:"Cupones de descuentos tendrán una vigencia de 12 meses.",
          expand:false
        },
        {
          title:"¿Cómo puedo validar el estatus de mis referidos y/o cupones?",
          description:"Una vez hayas registrado su cuenta en Mi Claro, podrás acceder al programa de referidos para ver el estatus de sus cupones.",
          expand:false
        }
      ]
    };
  }

  dataLoading(sw) {
    this.expand[0] = false;
  }
  ocultarPreguntasFrecuentes(){
    this.updatescreenview.emit(1);
  }
  updateExpand(index) {
    this.expand[index] = !this.expand[index];
  }

}
